import axios from 'axios';

export const postConnectSpenditUser = async (path: string, params: PostConnectParams) => {
  const res = await axios.post(path, params);

  return res.data;
};
